<template>
<div class="mb-3 col-sm-6 col-md-4 col-lg-4 col-xl-3 item">
  <div class="thumbnail card d-none d-md-flex" :class="{'item-disabled': item.disabled}">
    <div class="img-event intrinsic">
      <img :src="item.thumbnail_url" alt="" class="thumbnail-image card-img-top intrinsic-item p-0">
    </div>
    <div class="card-body">
      <div class="row mx-0 h-100">
        <div class="col-12 p-0">
          <h6>{{ item.title }}</h6>
          <p class="card-text truncate">{{ item.description | shortDescription}}</p>
        </div>
        <div class="col-12 p-0 align-self-end mt-4">
          <div class="row">
            <p class="col-12 lead">R {{ item.price }}</p>
            <div class="col-12 pointer" @click="disableIt">
              <div class="row m-0 justify-content-between">
                <div class="col p-0">
                  Active
                </div>
                <div class="col p-0 text-right">
                  <span class="material-icons toggle_off" v-if="item.disabled">
                    toggle_off
                  </span>
                  <span class="material-icons toggle_on" v-else>
                    toggle_on
                  </span>
                </div>
              </div>
            </div>
            <div class="col-12 mb-1 pointer" @click="soldOut">
              <div class="row m-0 justify-content-between">
                <div class="col p-0">
                  In Stock
                </div>
                <div class="col p-0 text-right">
                  <span class="material-icons toggle_off" v-if="item.soldOut">
                    toggle_off
                  </span>
                  <span class="material-icons toggle_on" v-else>
                    toggle_on
                  </span>
                </div>
              </div>
            </div>
            <div class="col-12">
              <button class="btn btn-outline w-100" @click="$emit('edit', item)">
                Edit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card d-md-none" :class="{'item-disabled': item.disabled}">
    <div class="row m-0">
      <div class="col-3 p-0">
        <img :src="item.thumbnail_url" alt="" class="img-fluid img_height">
      </div>
      <div class="col px-3 py-2">
        <div class="row m-0">
          <div class="col-10 p-0 truncate_2 bold">
            {{ item.title }}
          </div>
          <div class="col p-0 text-right" @click="disableIt">
            <span class="material-icons toggle_off" v-if="item.disabled">
              toggle_off
            </span>
            <span class="material-icons toggle_on" v-else>
              toggle_on
            </span>
          </div>
          <div class="col-12 p-0 mt-1">
            <div class="row align-items-center">
              <div class="col-5 lead m-0">R {{ item.price }}</div>
              <div class="col">
                <button class="btn btn-outline w-100" @click="$emit('edit', item)">
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: ['item', 'displayList'],
  methods: {
    ...mapActions(['updateItem']),
    disableIt () {
      this.item.disabled = !this.item.disabled
      this.updateItem(this.item)
    },
    soldOut () {
      this.item.soldOut = !this.item.soldOut
      this.updateItem(this.item)
    }
  },
  filters: {
    shortDescription (value) {
      if (value && value.length > 150) {
        return value.substring(0, 150) + '...'
      } else {
        return value
      }
    }
  }
}
</script>

<style lang="scss" scoped>
div.card {
  height: 100%;
}
.card-title {
  color: #3eaf7c;
  height: 2.5rem;
}
.card-text {
  font-size: 0.875rem;
}

.remain {
  color: #d17581;
}

.grow {
  transition: all .2s ease-in-out;
}

.grow:hover {
  transform: scale(1.1);
}

.list-group-item {
  float: none;
  width: 100%;
  background-color: #fff;
  margin-bottom: 30px;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
  padding: 0 1rem;
  border: 0;
  .thumbnail {
    display: inline-block;
    width: 100%;
  }
  .img-event {
    width: 20%;
    float: left;
    padding: 0 !important;
    margin: 0;
    height: auto;
  }

  .thumbnail-image {
    position: static;
  }

  .card-body {
    float: left;
    width: 90%;
    margin: 0;
  }

  @media (max-width: 767.98px) {
    .img-event {
      width: 30%;
      float: left;
      padding: 0 !important;
      margin: 0;
    }

    .card-body {
      float: left;
      width: 70%;
      margin: 0;
    }
  }
}

.item.list-group-item:before, .item.list-group-item:after
{
    display: table;
    content: " ";
}

.item.list-group-item:after {
  clear: both;
}
.item-disabled {
  opacity: 0.4;
  // background-color: gray;
}
.edit_icon {
  cursor: pointer;
  position: absolute;
  font-size: 0.7rem;
  top: 0;
  right: 0;
  z-index: 2;
  color: var(--dark-color);
  background-color: var(--light-color);
}
.edit_icon_small {
  cursor: pointer;
  position: absolute;
  font-size: 0.7rem;
  top: 0;
  z-index: 2;
  color: var(--dark-color);
  background-color: var(--light-color-07);
  left: 0;
}
.edit_icon .material-icons {
  font-size: 0.7rem;
}
.edit_icon_small .material-icons {
  font-size: 0.5rem;
}
.dark-mode .edit_icon {
  background-color: var(--dark-color-off);
  color: var(--light-color);
}
.dark-mode .edit_icon_small {
  background-color: var(--dark-color-off);
  color: var(--light-color);
}
</style>
